import React from "react";
import Tooltip from "react-tooltip";
import { InfoIcon } from "../../../../assets/Icons/InfoIcon";

const AbandonedInfoMessages = ({ obj }) => {
  const isAbandonedEnrollment = obj.is_abandoned_enrollment;
  const isPendingDeletion = obj.is_pending_deletion;
  const showMessage = isAbandonedEnrollment || isPendingDeletion;

  return showMessage ? (
    <>
      <span data-tip data-for="infoToolTip">
        <InfoIcon
          width={"15px"}
          color={isAbandonedEnrollment ? "orange" : "red"}
        />
      </span>{" "}
      <Tooltip id="infoToolTip" aria-haspopup="true">
        {isAbandonedEnrollment
          ? "Enrollment was not completed in the last 6+ months"
          : "Grace period has started. Will be auto-deleted soon"}
      </Tooltip>
    </>
  ) : null;
};

export default AbandonedInfoMessages;
